import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApiMembersEmployeesShowResponseType } from "~/domains";

type RequestDataType = {
  id: string;
};

const request = async ({
  id,
}: RequestDataType): Promise<ApiMembersEmployeesShowResponseType> => {
  const response =
    await new ApiClient().get<ApiMembersEmployeesShowResponseType>(
      `/api/members/employees/${id}`,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  id: string;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisMembersEmployeesShow = ({
  id,
  config = {},
}: PropsType): UseQueryResult<ApiMembersEmployeesShowResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisMembersEmployeesShow", id],
    queryFn: () => request({ id }),
  });
};
